import React, { FC, useState } from 'react'

import { UpgradePlanModal } from 'src/components/UpgradePlanModal'

import styles from './trialExpiredBanner.module.scss'

interface CustomMessage {
  text?: string
  title?: string
}

interface TrialExpiredBannerProps {
  customMessage?: CustomMessage
}

export const TrialExpiredBanner: FC<TrialExpiredBannerProps> = ({
  customMessage,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const customTitle = customMessage?.title?.trim() || ''
  const customText = customMessage?.text?.trim() || ''
  const hasCustomMessage = !!customTitle || !!customText

  return (
    <>
      <div className={styles.banner}>
        <div className={styles.content}>
          <div className={styles.iconWrapper}>
            <img alt="Warning" height={21} src="/warning.svg" width={24} />
          </div>
          <div className={styles.textContent}>
            {hasCustomMessage ? (
              <>
                {customTitle && (
                  <div className={styles.title}>{customTitle}</div>
                )}
                {customText && (
                  <div className={styles.message}>{customText}</div>
                )}
              </>
            ) : (
              <>
                <div className={styles.title}>Trial Period Ended</div>
                <div className={styles.message}>
                  Your trial has expired. Upgrade your plan to continue
                  accessing all Hapttic features.
                </div>
              </>
            )}
          </div>
        </div>
        <button
          className={styles.contactButton}
          onClick={() => setIsModalOpen(true)}
          type="button"
        >
          {hasCustomMessage ? 'Contact Admin' : 'Contact Admin to Upgrade'}
        </button>
      </div>

      <UpgradePlanModal
        description="If you'd like to activate a Custom Plan, please contact our Support team."
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        title="Contact Support"
      />
    </>
  )
}
